@if (filtersForm() && controlName()) {
  <vectronic-filter-header
    (titleClicked)="toggleShowFilter()"
    title="{{ title() }}"
    [svgIcon]="svgIcon()"
    [icon]="icon()"
    (enabledFilterToggle)="toggleShowFilter()"
    [isFilterEnabled]="isFilterHidden()"
  ></vectronic-filter-header>

  <div
    class="utc-filter filter-body"
    [hidden]="!isFilterHidden()"
    [formGroup]="filtersForm()"
    (click)="filtersForm().get(filterEnableControl()).setValue(true)"
  >
    <mat-radio-group
      class="utc-filter__radio-group"
      aria-label="Select an option"
      [formControlName]="controlName()"
      (change)="onRadioChange($event)"
    >
      <mat-radio-button class="utc-filter__radio-button" value="time-span" color="primary">
        Time Span [UTC]
      </mat-radio-button>
      @if (filtersForm().get(controlName()).value === 'time-span') {
        <div>
          <mat-form-field class="utc-filter__datepicker" appearance="outline">
            <mat-label>From</mat-label>
            <input
              autocomplete="off"
              matInput
              (focus)="tplutcFrom.open()"
              [matDatepicker]="tplutcFrom"
              class="datepicker"
              [formControlName]="utcFromDateControlName()"
            />
            <mat-hint>{{ dateFormat }}</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="tplutcFrom"></mat-datepicker-toggle>
            <mat-datepicker #tplutcFrom></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="utc-filter__datepicker pt-6" appearance="outline">
            <mat-label>To</mat-label>
            <input
              matInput
              autocomplete="off"
              (focus)="tplutcTo.open()"
              [min]="filtersForm().get(utcFromDateControlName()).value"
              [matDatepicker]="tplutcTo"
              class="datepicker"
              [formControlName]="utcToDateControlName()"
            />
            <mat-hint>{{ dateFormat }}</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="tplutcTo"></mat-datepicker-toggle>
            <mat-datepicker #tplutcTo></mat-datepicker>
          </mat-form-field>
        </div>
      }

      @if (isLocalTimeFilterVisible() && timeService.shouldShowLocalTime()) {
        <div>
          <mat-radio-button class="utc-filter__radio-button" value="time-span-lmt" color="primary">
            Time Span [LMT]
          </mat-radio-button>
          @if (filtersForm().get(controlName()).value === 'time-span-lmt') {
            <div>
              <mat-form-field class="utc-filter__datepicker" appearance="outline">
                <mat-label>From</mat-label>
                <input
                  autocomplete="off"
                  matInput
                  (focus)="tpllmtFrom.open()"
                  [matDatepicker]="tpllmtFrom"
                  class="datepicker"
                  [formControlName]="lmtFromDateControlName()"
                />
                <mat-hint>{{ dateFormat }}</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="tpllmtFrom"></mat-datepicker-toggle>
                <mat-datepicker #tpllmtFrom></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="utc-filter__datepicker pt-6" appearance="outline">
                <mat-label>To</mat-label>
                <input
                  matInput
                  autocomplete="off"
                  (focus)="tpllmtTo.open()"
                  [min]="filtersForm().get(lmtFromDateControlName()).value"
                  [matDatepicker]="tpllmtTo"
                  class="datepicker"
                  [formControlName]="lmtToDateControlName()"
                />
                <mat-hint>{{ dateFormat }}</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="tpllmtTo"></mat-datepicker-toggle>
                <mat-datepicker #tpllmtTo></mat-datepicker>
              </mat-form-field>
            </div>
          }
        </div>
      }

      <mat-radio-button class="utc-filter__radio-button" value="recent" color="primary">
        Recent
      </mat-radio-button>
      @if (filtersForm().get(controlName()).value === 'recent') {
        <div class="utc-filter__container">
          <mat-form-field class="utc-filter__recent" id="last-input-form" appearance="outline">
            <input
              autocomplete="off"
              matInput
              type="number"
              #input
              maxlength="6"
              min="1"
              (change)="onRecentValChange()"
              [formControlName]="recentValue()"
            />
          </mat-form-field>
          <mat-form-field class="utc-filter__recent" id="unit-input-form" appearance="outline">
            <mat-label>Unit</mat-label>
            <mat-select [formControlName]="recentUnit()">
              <mat-option value="h">Hours</mat-option>
              <mat-option value="d">Days</mat-option>
              <mat-option value="w">Weeks</mat-option>
              <mat-option value="M">Months</mat-option>
              <mat-option value="y">Years</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }
    </mat-radio-group>
  </div>
}
